(() => {
  const publish = (name, data = {}) => {
    if (!window.Shopify?.analytics?.publish) return;

    try {
      const result = window.Shopify.analytics.publish(name, data);
      if (result?.catch) result.catch(() => {});
    } catch (_error) {
      // Analytics must never interrupt the buying experience.
    }
  };

  const productContext = (element) => {
    const productInfo = element?.closest('product-info') || document.querySelector('product-info[data-product-id]');
    return {
      product_id: productInfo?.dataset.productId || '',
      product_handle: productInfo?.dataset.productHandle || '',
      market_country: productInfo?.dataset.marketCountry || '',
    };
  };

  document.addEventListener('change', (event) => {
    const option = event.target.closest('variant-selects input, variant-selects select');
    if (!option) return;

    const optionContainer = option.closest('[data-option-name], .product-form__input');
    const optionName = optionContainer?.dataset.optionName || option.name || '';
    if (!optionName.toLowerCase().includes('size')) return;

    publish('mission_size_selected', {
      ...productContext(option),
      option_name: optionName,
      option_value: option.value,
    });
  });

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-sticky-submit]');
    if (stickyButton) {
      const stickyBar = stickyButton.closest('mobile-sticky-atc');
      const sourceForm = stickyBar?.dataset.sourceForm ? document.getElementById(stickyBar.dataset.sourceForm) : null;
      publish('mission_sticky_atc_clicked', {
        ...productContext(stickyButton),
        variant_id: sourceForm?.querySelector('[name="id"]')?.value || '',
      });
      return;
    }

    const discoveryLink = event.target.closest('.product-discovery-section a[href*="/products/"]');
    if (discoveryLink) {
      const section = discoveryLink.closest('.product-discovery-section');
      publish(section.classList.contains('product-complementary') ? 'mission_this_goes_with_clicked' : 'mission_more_from_mission_clicked', {
        ...productContext(discoveryLink),
        destination_handle: discoveryLink.pathname.split('/products/')[1]?.split(/[?#]/)[0] || '',
      });
      return;
    }

    const referralCta = event.target.closest('[data-mission-referral-cta], [data-mission-copy-link], [data-mission-native-share]');
    if (referralCta) {
      publish('mission_referral_cta_clicked', {
        source: referralCta.dataset.missionReferralCta || (referralCta.hasAttribute('data-mission-copy-link') ? 'copy_link' : 'native_share'),
      });
      return;
    }

    const sizingTab = event.target.closest('[class*="fit-sizing-tab-"][data-tab]');
    if (sizingTab) {
      publish('mission_size_reference_opened', {
        ...productContext(sizingTab),
        reference_type: sizingTab.dataset.tab || '',
      });
    }
  });

  window.MissionAnalytics = { publish };
})();
